import { render, staticRenderFns } from "./knowledgebasepopup.vue?vue&type=template&id=6ee1c5ca&scoped=true&"
import script from "./knowledgebasepopup.vue?vue&type=script&lang=js&"
export * from "./knowledgebasepopup.vue?vue&type=script&lang=js&"
import style0 from "./knowledgebasepopup.vue?vue&type=style&index=0&id=6ee1c5ca&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee1c5ca",
  null
  
)

export default component.exports